import { render, staticRenderFns } from "./PatientDoseSpotActiveMedicationsV1Properties.vue?vue&type=template&id=66a16d45&"
import script from "./PatientDoseSpotActiveMedicationsV1Properties.vue?vue&type=script&lang=js&"
export * from "./PatientDoseSpotActiveMedicationsV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports